import React from "react";
import { MTable, MuiTextField } from "components/Shared";
import { dateToString } from "components/Shared/Formatters";

export default (underwriterActionsAudits) => [{
  key: "customer-actions-history",
  control: (
    <MTable
      columnDefinitions={[
        { name: "User", dataSource: "name" },
        { name: "Date/Time", dataSource: "createDate" },
        { name: "Reviewer Actions Taken", dataSource: "actionTaken" },
        { name: "Comments", dataSource: "comments" },
      ]}
      data={underwriterActionsAudits.map(({ name, createDate, actionTaken, comments, id }) =>
        ({
          name,
          createDate: dateToString(createDate),
          actionTaken: (<MuiTextField
            value={actionTaken?.split("   ").join("\n")}
            multiline
            fullWidth
            disabled
          />),
          comments: (<MuiTextField
            value={comments}
            multiline
            fullWidth
            disabled
          />),
          key: id,
        }))}
      emptyTableText={"No Action History"}
    />
  ),
}];